module.exports = __webpack_public_path__ + "static/img/img_bg.3ca3e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_bg.png
// module id = Dwbk
// module chunks = 19